export default __webpack_public_path__ + "static/media/stainless-steel-studs.287c8a05.webp";